module.exports = "## Auto Complete\nThe [auto-complete](https://www.google.com/design/spec/components/text-fields.html#text-fields-auto-complete-text-field)\nis an extension of a regular text-field that will auto-complete the input dynamically. It can take different auto-complete filters and\nuses a menu to display suggestions.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/AutoComplete/README.md
 ** module id = 936
 ** module chunks = 0
 **/